import { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

import DelayBonusSettingListing from "./DelayBonusSettingListing";
import DelayBonusSettingEdit from "./DelayBonusSettingEdit";
// import DelayBonusSettingCreate from "./DelayBonusSettingCreate";

import * as actions from "../../store/ducks/delayBonusSetting/actions";
import { filterErrorHandler } from "../../hoc/Shared/utility";

class DelayBonusSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageShow: "listing",
            page: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalPages: 0,
            activePage: 1,
            totalRecords: 0,
            searchValue: "",
            data: [],
            selectId: null,
            loading: true,
        };
    }
    
    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.funcGetList(listingArr);
    }
    
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.dl !== this.props.dl && nextProps.dl !== undefined) {
            if (nextProps.dl.responseCode === 200 && nextProps.dl.msgType === "success") {
                this.setState({
                    data: nextProps.dl.data.result.row,
                    totalRecords: nextProps.dl.data.result.pagination.total_record,
                    loading: false,
                });
            } else {
                this.setState({
                    data: [],
                    totalRecords: 0,
                    loading: false
                }, () => {
                    filterErrorHandler(nextProps.dl.message);
                })
            }
        }
        return true;
    }
    
    loadingHandler = () => {
        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    };

    refreshHandler = () => {
        this.setState(
        {
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        },
        () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        }
        );
    };

    getFilterArray = () => {
        // this.loadingHandler();
        const listingArr = {};
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }

        listingArr.page =
        this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.country_id = this.props.currentUser.country_id;

        return listingArr;
    };

    detailsHandler = (e, page, id) => {
        e.preventDefault();
        this.setState({
            pageShow: page,
            selectId: id,
        });
    };

    changePageHandler = (page) => {
        // console.log(page);
        this.setState({
            pageShow: page,
            errMsg: [],
            touched: false,
        });
    };

    datatablesChangeHandler = (val, act) => {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState(
        {
            [act]: act === "searchValue" ? val.target.value : val,
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        },
        () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        }
        );
    };

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = order === "asc" ? true : false;

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState(
        {
            order: orderArry,
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        },
        () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        }
        );
    };

    render() {
        const { t } = this.props;
        let statusArr = [
            { label: t("global.active"), value: 1 },
            { label: t("global.inactive"), value: 0 },
        ];

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <DelayBonusSettingListing
                        onInputChange={(event) => this.onInputChange(event)}
                        datatablesChangeHandler={(val, act) =>
                        this.datatablesChangeHandler(val, act)
                        }
                        detailsHandler={(event, page, id) =>
                        this.detailsHandler(event, page, id)
                        }
                        changePageHandler={(event, page, id) =>
                        this.changePageHandler(event, page, id)
                        }
                        onSort={(field, order) => this.onSort(field, order)}
                        refreshHandler={() => this.refreshHandler()}
                        data={this.state.data}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}
                        loading={this.state.loading}
                        currentUser={this.props.currentUser}
                    />
                )}

                {/* {this.state.pageShow === "create" && (
                    <DelayBonusSettingCreate
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                        statusArr={statusArr}
                    />
                )} */}

                {this.state.pageShow === "edit" && (
                    <DelayBonusSettingEdit
                        selectId={this.state.selectId}
                        refreshHandler={() => this.refreshHandler()}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        statusArr={statusArr}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        dl: state.delayBonusSetting.dl,
        currentUser: state.currentUser.data,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        funcGetList: (filter) => dispatch(actions.getList(filter)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(DelayBonusSetting));
